import { render, staticRenderFns } from "./DSCameraIcon.vue?vue&type=template&id=2570fed4&scoped=true&"
import script from "./DSCameraIcon.vue?vue&type=script&lang=js&"
export * from "./DSCameraIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570fed4",
  null
  
)

export default component.exports